// extracted by mini-css-extract-plugin
export default {"error":"TextArea_error__SjI+C","errorMessage":"TextArea_errorMessage__1lG6T"};